<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    label="Name"
                    outlined
                    dense
                    hide-details="auto"
                    :value="name"
                    @input="$emit('update:name', $event)"
                    :rules="[isRequired]"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    label="G/L Account"
                    outlined
                    dense
                    hide-details="auto"
                    :value="ledgerAccountId"
                    @input="$emit('update:ledger-account-id', $event)"
                    @update:search-input="searchLedgerAccounts"
                    :items="ledgerAccounts"
                    item-text="display_name"
                    item-value="id"
                    :rules="[isRequired]"
                ></v-autocomplete>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import ledgerAccountService from '../../services/purchase/ledgerAccount';
import { isRequired } from './../../utils/validations';
export default {
    props: {
        name: String,
        ledgerAccountId: [String, Number],
        ledgerAccount: Object
    },
    data() {
        return {
            ledgerAccounts: [],
            ledgerAccountsLoading: false
        }
    },
    watch: {
        ledgerAccount: {
            deep: true,
            handler(val) {
                console.log(val)
                this.ledgerAccounts = [...this.ledgerAccounts, val];
            }
        }
    },
    methods: {
        isRequired,
        searchLedgerAccounts(query) {
            this.ledgerAccountsLoading = true;
            ledgerAccountService.search(query).then(res => {
                this.ledgerAccounts = [...this.ledgerAccounts, ...res.data]
            }).finally(() => {
                this.ledgerAccountsLoading = false;
            })
        }
    },
    created() {
        if(this.ledgerAccount) {
            this.ledgerAccounts = [...this.ledgerAccounts, this.ledgerAccount]
        }
    }
    
}
</script>

<style>

</style>